export default "/_next/static/images/unilever-ba19c0af90bf48eaea6d20bb7f16da6c.svg";